import classNames from 'classnames';
import React from 'react';

import styles from './styles.module.scss';

function Cell<T extends { className?: string }>(
  {
    children,
    className,
    as: Component = 'div',
    type = 'default',
    ...props
  }: React.PropsWithChildren<T & { as?: string | React.ComponentType<T>; type?: 'default' | 'full' }>,
  ref: React.Ref<HTMLElement>,
) {
  return (
    // @ts-ignore
    <Component ref={ref} className={classNames(styles.cell, className, styles[`cell__${type}`])} {...props}>
      {children}
    </Component>
  );
}

interface ListGridProps {
  className?: string;
}

export const ListGrid: React.FC<ListGridProps> & { Cell: typeof Cell } = ({ className, children }) => {
  return <div className={classNames(styles.grid, className)}>{children}</div>;
};

ListGrid.Cell = React.forwardRef<HTMLElement>(Cell) as typeof Cell;
